import { ChangeDetectionStrategy, Component, ElementRef, Input, OnChanges } from '@angular/core';

@Component({
	selector: 'safe-style',
	changeDetection: ChangeDetectionStrategy.OnPush,
	template: '',
    standalone: false
})
export class SafeStyleComponent implements OnChanges {
	@Input() public readonly css: string;
	private style: HTMLStyleElement;

	constructor(private readonly el: ElementRef) {}

	public ngOnChanges(): void {
		if(!this.style) {
			this.style = document.createElement('style');
			this.el.nativeElement.appendChild(this.style);
		}
		this.style.innerHTML = this.css;
	}
}
